import type { ToolbarCollectionState } from './ToolbarCollectionState';
import type { TaskState } from '@wix/bex-core';

export type ToolbarFeatureInitializer = (
  state: ToolbarCollectionState<any, any>,
) => {
  init: () => void | (() => void);
  initTask: TaskState<unknown> | null;
};
